import React from 'react';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { GridColDef } from '@mui/x-data-grid';
import CustomTable from 'components/misc/CustomTable';
import { useTranslation } from 'react-i18next';

const TableWidget: React.FC<{
  fields: string[] | null;
  data: any[] | null;
  getStatus: HttpFetchStatus;
  hideFooter?: boolean;
}> = ({ fields, data, getStatus, hideFooter }) => {
  const { t } = useTranslation();

  if (data == null) return null;

  const columns: GridColDef[] = Object.keys(data.length > 0 ? data[0] : [])
    .filter((f) => fields == null || fields.includes(f))
    .map((f) => ({ field: f, headerName: t('fleet-management-field-' + f) }));

  return (
    <React.Fragment>
      <CustomTable
        getStatus={getStatus}
        dataLoaded={data != null}
        loadingMessage={t('loading-dataset')}
        failedToLoadMessage={t('error-loading-data')}
        emptyDataMessage={t('info-no-data-returned')}
        data={data ?? []}
        columns={columns}
        hideFooter={hideFooter}
      />
    </React.Fragment>
  );
};

export default TableWidget;
